import React from 'react'
import styled from 'styled-components'
import { useRouteMatch, useLocation, useHistory, Link } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'

const PoolTabButtons = () => {
  const { url } = useRouteMatch()
  const { pathname } = useLocation()
  const history = useHistory()
  const { t } = useTranslation()

  const isStakedOnly = pathname.includes('staked')
  const isFinished = pathname.includes('history')

  return (
    <Wrapper>
      <ToggleWrapper>
        <Toggle
          type="button"
          role="switch"
          aria-checked={isStakedOnly}
          aria-label={t('Staked only')}
          $checked={isStakedOnly}
          onClick={() => history.push(isStakedOnly ? url : `${url}/staked`)}
        />
        <ToggleLabel>{t('Staked only')}</ToggleLabel>
      </ToggleWrapper>
      <Tabs>
        <Tab to={url} $active={!isFinished && !isStakedOnly}>
          {t('Live')}
        </Tab>
        <Tab to={`${url}/history`} $active={isFinished}>
          {t('Finished')}
        </Tab>
      </Tabs>
    </Wrapper>
  )
}

export default PoolTabButtons

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 40px;
  width: 100%;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: auto;
    margin-bottom: 0;
  }
`

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`

const Toggle = styled.button<{ $checked: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 52px;
  height: 29px;
  padding: 0;
  border: 2px solid #1d2425;
  border-radius: 25px;
  background: ${({ $checked }) => ($checked ? '#fe7b2a' : '#475355')};
  cursor: pointer;
  transition: background 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $checked }) => ($checked ? '25px' : '2px')};
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background: #ffffff;
    transition: left 0.2s;
  }
`

const ToggleLabel = styled.span`
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  white-space: nowrap;
`

const Tabs = styled.div`
  display: flex;
  align-items: center;
  width: 257px;
  height: 34px;
  background: #374244;
  border: 3px solid #252c2d;
  border-radius: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`

const Tab = styled(Link)<{ $active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% + 6px);
  margin: -3px 0;
  border: ${({ $active }) => ($active ? '2px solid #2b3335' : '2px solid transparent')};
  border-radius: 10px;
  background: ${({ $active }) => ($active ? '#fe7b2a' : 'transparent')};
  color: ${({ $active }) => ($active ? '#ffffff' : 'rgba(255, 255, 255, 0.6)')};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: #ffffff;
  }
`
